import React from 'react'
import { Flex, MantineProvider, createTheme } from '@mantine/core'
import { QueryClient, QueryClientProvider } from 'react-query'
import { BackendMenu, ClientMenu } from '@config/menus'
import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'
import '@mantine/dates/styles.css'

import { Notifications } from '@mantine/notifications'
import { ModalsProvider } from '@mantine/modals'
import AuthProvider from './context/AuthContext'
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom'
import ClientHeader from '@components/header/ClientHeader'
import { colors } from './theme/colors'
import { useHeadings } from './theme/useHeadings'
import ProtectedRoute from '@utils/ProtectedRoute'
import SideBarMenu from '@components/header/SideBarMenu'

function App() {
    const headings = useHeadings()
    const theme = createTheme({
        primaryShade: 4,
        colors: colors as any,
        breakpoints: {
            xs: '0em',
            sm: '48em',
            md: '64em',
            lg: '74em',
            xl: '90em',
        },
        fontSizes: {
            xs: '12px',
            sm: '14px',
            md: '16px',
            lg: '18px',
            xl: '20px',
        },

        headings: headings,

        // fontFamily: 'Noto Sans Thai',
        fontFamily: 'KaLaTeXa',
        components: {},
        /** Put your mantine theme override here */
    })
    const queryClient = new QueryClient()
    const clientRouter = ClientMenu.filter((value) => value.path && true)
    const clientRouterList = clientRouter.map((value) => {
        return (
            <Route
                key={value.path}
                path={value.path}
                element={
                    <>
                        <ClientHeader />
                        {value.element}
                    </>
                }
            />
        )
    })
    const backendRouter = BackendMenu.filter((value) => value.path && true)
    const backendRoutesList = backendRouter.map((value) => {
        if (value.protected === true) {
            return (
                <Route
                    key={value.path}
                    path={value.path}
                    element={
                        <ProtectedRoute role={value.role}>
                            <Flex mih='100vh'>
                                <SideBarMenu />
                                {value.element}
                            </Flex>
                        </ProtectedRoute>
                    }
                />
            )
        } else {
            return (
                <Route
                    key={value.path}
                    path={value.path}
                    element={value.element}
                />
            )
        }
    })
    return (
        <QueryClientProvider client={queryClient}>
            <MantineProvider defaultColorScheme='light' theme={theme}>
                <Notifications position='top-right' />
                <ModalsProvider>
                    <AuthProvider>
                        <Router>
                            <Routes>
                                {backendRoutesList}
                                {clientRouterList}
                            </Routes>
                        </Router>
                    </AuthProvider>
                </ModalsProvider>
            </MantineProvider>
        </QueryClientProvider>
    )
}

export default App
